import React from 'react'
import ProductLocationProvider from '../context/ProductLocationProvider'
import ProductLocationMain from './ProductLocationMain'


const ProductLocationLayout = () => {
  return (
    <ProductLocationProvider>
      <ProductLocationMain />
    </ProductLocationProvider>
  )
}

export default ProductLocationLayout